import getEnv from "@utils/getEnv";

const getFbPixelId = (locale?: string): string | undefined => {
  if (locale === "lt") {
    return getEnv("NEXT_PUBLIC_FACEBOOK_PIXEL_ID_LT");
  }
  if (locale === "lv") {
    return getEnv("NEXT_PUBLIC_FACEBOOK_PIXEL_ID_LV");
  }
  if (locale === "ee") {
    return getEnv("NEXT_PUBLIC_FACEBOOK_PIXEL_ID_EE");
  }
  return undefined;
};
export default getFbPixelId;
